import { axios } from "./init";
import Cookies from 'js-cookie'
/**
 * 手机验证码登录
 *  data {
 *    username: 手机号,
 *    vcode: 图形验证码,
 *    code: 动态验证码,
 *    additional: did+'@'+sid （诸葛）
 *  }
 *
 */

export function phoneLogin(data) {
  let headers={"Content-Type": "application/json; charset=utf-8"}
  let type=''
  if(window.location.search.indexOf('match')>-1){
      type='competition'
  }
  if(type){
    headers['bxg-origin']=type
  }
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/user/login/mobile`,
    method: "post",
    data: data,
    headers: headers,
  });
}

/**
 *  用户名证码登录
 *  data {
 *    username: 手机号或邮箱,
 *    password: 密码,
 *    additional: did+'@'+sid （诸葛）
 *  }
 *
 */

export function userLogin(data) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/user/login`,
    method: "post",
    data: data,
    headers: {
      
      "Content-Type": "application/json; charset=utf-8",
    },
  });
}

/**
 *  获取动态验证码
 *  data {
 *    mobileOrEmail: 手机号或者邮箱,
 *    vType: 1 
 *    messageType:   消息类型：1-发送手机消息，2-发送邮箱消息
 *  }
 * 
 */

export function getDynamicCode(params) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/user/auth/newSendDynamicCode`,
    method: "get",
    params: params
  });
}

/**
 *  验证动态码
 *  data {
 *    phone: 手机号,
 *    vcode: 图形验证码,
 *    code: 短信动态码
 *  }
 *
 */

export function checkCode(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/verificationCode/checkCode`,
    method: "post",
    data: data,
    crossDomain: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "bxg-platform": "pc",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 *  获取登录注册二维码
 *  params {
 *    code: 当前时间戳
 *  }
 *
 */

export function getQRcode(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_WEIXIN}/bxg/core/create`,
    method: "post",
    params: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 *  验证扫码后是否登录
 *  params {
 *    code: 获取二维码的时间戳,
 *    time: 当前时间戳
 *  }
 *
 */

export function verifyLoginStatus(params) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/user/auth/wechat/status`,
    method: "GET",
    params: params,
  });
}

/**
 *  手机是否注册
 *  data {
 *    username: 手机号
 *  }
 *
 */

export function valiAccount(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/user/valiAccount`,
    method: "post",
    data: data,
    crossDomain: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "bxg-platform": "pc",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 *  手机注册
 *  data {
 *    username: 手机号,
 *    password: 密码,
 *    vcode: 图形验证码,
 *    code: 动态验证码,
 *    registType: 2,
 *    additional: did+'@'+sid （诸葛）
 *  }
 *
 */

export function phoneRegist(data) {
  let headers={
    "bxg-platform": "pc",
    "Content-Type": "application/x-www-form-urlencoded",
  }
  let type=''
    if(window.location.search.indexOf('match')>-1){
      type='competition'
  }
  if(type){
    headers['bxg-origin']=type
    data.userOrigin='ONLINE'
  }
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/user/auth/phoneRegist`,
    method: "post",
    data: data,
    crossDomain: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers:headers,
  });
}

/**
 *  手机重置用户密码
 *  data {
 *    username: 手机号,
 *    password: 密码,
 *    additional:did+"@"+sid
 *  }
 *
 */

export function resetUserPassword(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/user/auth/resetUserPassword`,
    method: "post",
    data: data,
    crossDomain: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "bxg-platform": "pc",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 *  手机重置用户密码
 *  data {
 *    username: 手机号,
 *    password: 密码
 *  }
 *
 */

export function resetPasswordByEmail(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/user/resetPasswordByEmail`,
    method: "post",
    data: data,
    crossDomain: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "bxg-platform": "pc",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 *  验证邮箱用户是否存在
 *  data {
 *    email: 邮箱,
 *    refer: 要跳转的链接,
 *  }
 *
 */

export function sendemail(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/user/auth/sendemail`,
    method: "post",
    data: data,
    crossDomain: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "bxg-platform": "pc",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 *  微信服务号登录绑定已有账号
 *  data {
 *  }
 *
 */

export function bindAccount(data) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/user/bind/Account`,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

/**
 *  微信服务号登录绑定已有账号
 *  data {
 *  }
 *
 */

export function bindEmail(data) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/user/bind/mobile`,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

//邮箱跳到页面是否展示手机号和验证码

export function getToResetEmail(params) {
  return axios({
    url: `${process.env.VUE_APP_BASE_PATH_ONLINE}/online/user/auth/toResetEmail`,
    method: "get",
    params: params,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
  });
}

/**
 *  生成验证码拼图
 *  data {
 *  }
 *
 */

export function createCaptcha(data) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/captcha/createCaptcha`,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}
/**
 *  验证码拼图校验
 *  
 */

export function validCaptcha(params) {
  return axios({
    url: `${process.env.VUE_APP_NEW_URL}/portal-study/captcha/validCaptcha`,
    method: "GET",
    params: params,
  });
}
// 校验是否登录
export function isAlive() {
  return axios({
    url: process.env.VUE_APP_BASE_PATH_ONLINE + '/online/user/isAlive',
    method: 'get'
  })
}
// 重置密码
export function postResetUserPassword(data) {
  let config={
    url: process.env.VUE_APP_NEW_URL + '/portal-study/personal/resetUserPassword',
    method: "POST",
    headers:{
      'Content-Type': 'application/json'
    },
    data: data
  }
   // 用户标识
  const sign = Cookies.get('_uc_t_') ? Cookies.get('_uc_t_').split(';')[2] : ''
  console.log(sign,'sign')
  
  if(sign) localStorage.setItem('sign',sign)
  return axios(config);
}
// 重置密码
export function postInitPassword(data) {
  let config={
    url: process.env.VUE_APP_NEW_URL + '/portal-study/personal/initPassword',
    method: "POST",
    headers:{
      'Content-Type': 'application/json'
    },
    data: data
  }
   // 用户标识
  const sign = Cookies.get('_uc_t_') ? Cookies.get('_uc_t_').split(';')[2] : ''
  console.log(sign,'sign')
  
  if(sign) localStorage.setItem('sign',sign)
  return axios(config);
}